const en_extra = {
  clients: {
    title: "Client pipeline",
    subtitle: "Manage requests, negotiations and bookings.",
    new_client: "New Client",
    new_client_title: "New client",
    partner1: "Partner 1",
    partner2: "Partner 2",
    email: "Email",
    phone: "Phone",
    wedding_date: "Wedding date",
    acquisition: "Acquisition channel",
    create: "Create client",
    counts: {
      total: "Total",
      negotiating: "Negotiating",
      confirmed: "Confirmed",
      done: "Completed",
      lost: "Lost",
    },
    search_placeholder: "Search by name or email",
    all_stages: "All stages",
    linked_event_pill: "Event linked",
    no_clients: "No clients",
    no_clients_subtitle: "Add your first client to get started.",
    no_clients_search: "No results",
    no_clients_search_subtitle: "No clients match the current search or filter.",
    wedding: "Wedding",
    tab: {
      panoramica: "Overview",
      evento: "Event",
      comunicazioni: "Communications",
      questionario: "Questionnaire",
      documenti: "Documents",
      note: "Notes",
    },
    detail: {
      data_title: "Client data",
      crm_title: "CRM",
      type: "Type",
      stage: "Stage",
      updated: "Updated",
      linked_event: "Linked event",
      open_event: "Open event",
      go_event: "Go to event →",
      no_event: "No event linked.",
      no_event_title: "No wedding linked yet",
      no_event_hint: "Promote this client to create a pre-filled event with the partners' name and wedding date. Contact data stays in the CRM.",
      promote_to_event: "Promote to event",
      promoted_ok: "Event created and linked to client",
      no_comms: "No communications.",
      channel: "Channel",
      all_channels: "All channels",
      new_comm: "New interaction",
      synthesis: "Summary",
      outcome: "Outcome",
      save: "Save",
      saved: "Notes saved",
      notes_label: "Internal notes",
      send_questionnaire: "Send questionnaire link",
      questionnaire_title: "Questionnaire",
      questionnaire_desc: "Automatic delivery of a personalized link to the client.",
      documents_placeholder: "Client-dedicated documents upload.",
      coming_soon: "Coming soon",
      stage_updated: "Stage updated to \"{{stage}}\"",
    },
  },
  calendar: {
    title: "Central agenda",
    new_alert: "New Alert",
    new_alert_title: "New alert",
    title_label: "Title",
    date: "Date",
    type: "Type",
    legend: {
      Pagamento: "Payment",
      Task: "Task",
      Promemoria: "Reminder",
      Avviso: "Alert",
      Google: "Google",
      Evento: "Event",
    },
    days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    no_events: "No events on this date.",
    saved: "Alert added",
    today: "Today",
    add_here: "Add here",
    quick_add_title: "New note or commitment",
    notes_label: "Notes (optional)",
    cancel: "Cancel",
  },
  suppliers: {
    title: "Vendors Address Book",
    subtitle: "Your vendor network, reusable across all events.",
    new_supplier: "New Vendor",
    new_supplier_title: "New vendor",
    edit_title: "Edit vendor",
    modal_eyebrow: "Vendors address book",
    save_supplier: "Save vendor",
    update_supplier: "Update vendor",
    events_managed: "Events managed: {{n}}",
    name: "Name",
    category: "Category",
    price_range: "Price band",
    email: "Email",
    phone: "Phone",
    rating: "Rating",
    rating_label_full: "Rating (0–5 stars)",
    rating_help: "Your internal score for this vendor — 0 = not rated yet, 5 = excellent.",
    notes: "Notes",
    all_categories: "All categories",
    search_placeholder: "Search by name",
    empty_title: "Empty address book",
    empty_subtitle: "Add the first vendor to your network.",
    rating_label: "Rating",
    band_label: "Band",
    added: "Vendor added",
    updated: "Vendor updated",
    deleted: "Vendor removed",
    delete_confirm: "Permanently remove this vendor from the address book?",
    tabs: {
      anagrafica: "Profile",
      contatti: "Contacts",
      amministrazione: "Administration",
    },
    fields: {
      name: "Vendor name",
      category: "Category",
      city: "City",
      contact_person: "Contact person",
      email: "Email",
      phone: "Phone",
      website: "Website",
      instagram: "Instagram",
      notes: "Internal notes",
      agency_discount: "Agency discount",
      iban: "IBAN",
      account_holder: "Account holder",
      account_holder_hint: "If different from the legal name",
      deposit_required: "Required deposit",
      payment_terms: "Payment terms",
      rating: "Internal rating",
    },
    placeholders: {
      name: "e.g. Villa Medici",
      city: "e.g. Milan",
      contact_person: "e.g. Marco Bianchi",
      email: "info@...",
      phone: "+39 ...",
      website: "https://...",
      instagram: "@profilename",
      notes: "Quick notes or reminders...",
      agency_discount: "e.g. 10",
      deposit_required: "e.g. 30",
      iban: "IT60 X054 2811 1010 0000 0123 456",
      account_holder: "Full name or legal entity",
      payment_terms: "Select term...",
      regime: "Select regime...",
    },
    fiscal_section: "Fiscal data",
    economic_section: "Economic terms",
    evaluation_section: "Internal evaluation",
    fiscal: {
      legal_name: "Legal name",
      legal_name_hint: "e.g. Villa Medici Ltd.",
      vat_number: "VAT number",
      tax_code: "Tax code",
      sdi_code: "SDI code",
      regime_fiscale: "Tax regime",
      pec_email: "PEC email",
      address: "Registered address",
    },
    stats_section: "Statistics",
    stats_events_label: "Events managed with this vendor",
    stats_events_hint: "Total count of links across all active and past events.",
    contracts: {
      section: "Contracts",
      moved_hint: "This vendor's contracts are uploaded and managed inside the event, in the «Contracts» tab. That way each wedding keeps its own contracts.",
      format_hint: "Accepted formats: PDF · DOCX · CSV.",
      upload: "Upload contract",
      uploading: "Uploading…",
      uploaded: "Contract uploaded",
      empty: "No contracts uploaded. Add the vendor's contracts here.",
      download: "Download",
      remove: "Remove",
      delete_confirm: "Delete this contract? It will also be removed from linked events.",
    },
  },
  settings: {
    title: "Profile & Studio",
    account_title: "Account",
    name: "Name",
    agency: "Agency name",
    email: "Email",
    greeting: "Salutation",
    greeting_neutro: "Neutral",
    greeting_signora: "Mrs",
    greeting_signor: "Mr",
    saved: "Profile updated",
    theme_lang_title: "Theme & Language",
    theme: "Theme",
    language: "Language",
    italian: "Italian",
    english: "English",
    logo_title: "Agency logo",
    logo_desc: "Upload a PNG, JPG or SVG logo (200×200 recommended, max 2MB). It will appear in the sidebar.",
    google_title: "Google Calendar",
    google_desc: "Connect your Google account: weddings, tasks, payments and reminders from Aurea will appear in a dedicated \"Aurea Pro\" calendar, updated automatically within a few minutes.",
    google_connect: "Connect Google Calendar",
    google_disconnect: "Disconnect",
    google_reconnect: "Reconnect",
    google_connected_as: "Connected as",
    google_last_sync: "Last sync",
    google_never: "never",
    google_sync_now: "Sync now",
    google_sync_started: "Sync started",
    google_sync_running: "Sync already running…",
    google_expired: "Google Calendar disconnected. Reconnect your account.",
    google_not_configured: "Google integration is not configured on the server.",
    google_prefs_title: "What to sync",
    google_pref_events: "Weddings",
    google_pref_tasks: "Tasks",
    google_pref_payments: "Payments",
    google_pref_reminders: "Reminders",
    google_connected_toast: "Google Calendar connected",
    google_error_toast: "Google connection failed",
    google_disconnected_toast: "Google Calendar disconnected",
    upload_logo: "Upload logo",
    remove_logo: "Remove logo",
    plan_title: "Subscription plan",
    plan_label: "Plan",
    plan_active: "Active plan",
    plan_activate: "Activate with Stripe",
    plan_purchased_at: "Purchased on",
    plan_trial_ends_at: "Free trial ends on",
    plan_expires_at: "Expires on",
    plan_status_lifetime: "Lifetime",
    plan_lifetime_label: "Access",
    plan_lifetime_never_expires: "Forever",
    plan_lifetime_note: "Lifetime Premium. No renewal, no charges.",
    plan_renews_at: "Next renewal",
    plan_holder: "Holder",
    plan_interval: "Billing",
    plan_interval_month: "Monthly",
    plan_interval_year: "Yearly",
    plan_days_left: "{{n}} days left",
    plan_premium_note: "Auto-renewal is now active: you'll receive an email 7 days before the next charge.",
    plan_autorenew_on: "Auto-renewal is active. We'll email you 7 days before the next charge.",
    plan_autorenew_off: "Auto-renewal disabled. Renew manually to stay active.",
    plan_status: "Status",
    plan_status_active: "Active",
    plan_status_trial: "You're on the free trial",
    plan_status_past_due: "Payment failed",
    plan_status_canceled: "Canceled",
    plan_status_expiring: "Expiring soon",
    plan_renew_now: "Renew now",
    plan_admin_active: "Admin plan — managed manually",
    plan_billing_not_linked: "Stripe billing is not yet linked to this account. Connect it to manage renewals and invoices.",
    plan_link_stripe: "Connect Stripe billing",
    plan_manage: "Manage subscription",
    plan_change_plan: "Change plan",
    plan_downgrade: "Downgrade to Base",
    plan_downgrade_done: "Plan switched to Base",
    billing_cycle: "Billing cycle",
    billing_monthly: "Monthly",
    billing_yearly: "Yearly",
    billing_yearly_save: "12 months at the price of 12 — no extra discount",
    billing_per_month: "/mo",
    billing_per_year: "/yr",
    billing_yearly_equiv: "{{price}} per year",
    stripe_test_notice: "Stripe test mode: use card 4242 4242 4242 4242 with any future expiry and CVC.",
    stripe_redirect: "Redirecting to Stripe…",
    portal_redirect: "Opening Stripe portal…",
    base_caps: ["Max 3 active events", "All core features", "Email support"],
    premium_caps: [
      "Unlimited events",
      "Multi-user / team",
      "Drag & drop seating chart",
      "Guest CSV import + public RSVP",
      "Priority support",
    ],
    team_title: "Team members",
    team_owner: "Owner",
    team_collaborator: "Collaborator",
    team_empty: "No collaborator invited yet.",
    team_invite: "Invite member",
    team_invite_title: "Invite collaborator",
    team_invited: "Invitation sent",
    team_removed: "Member removed",
    delete_reason_costo: "Too expensive",
    delete_reason_poco_utilizzo: "I don't use it enough",
    delete_reason_attivita_chiusa: "I closed or paused my business",
    delete_reason_altro_gestionale: "I moved to another tool",
    delete_reason_funzioni_mancanti: "Missing features I need",
    delete_reason_troppo_complicato: "Too complicated to use",
    delete_reason_problemi_tecnici: "Technical problems or errors",
    delete_reason_account_di_prova: "It was just a test account",
    delete_reason_privacy: "Concerns about data privacy",
    delete_reason_non_dico: "I'd rather not say",
    delete_unit_events_one: "event",
    delete_unit_clients_one: "client",
    delete_unit_suppliers_one: "supplier",
    delete_unit_guests_one: "guest",
    delete_unit_payments_one: "payment",
    delete_unit_files_one: "file",
    delete_unit_events: "events",
    delete_unit_clients: "clients",
    delete_unit_suppliers: "suppliers",
    delete_unit_guests: "guests",
    delete_unit_payments: "payments",
    delete_unit_files: "files",
  },
  billing: {
    success_title: "Payment confirmed",
    success_msg: "Your Premium plan is active. Explore all the new features.",
    success_msg_base: "Your Base plan is active. Thank you!",
    polling: "Verifying payment…",
    failed: "Payment not confirmed. Please retry from Settings.",
    back_to_settings: "Back to Settings",
    go_dashboard: "Go to dashboard",
    cancelled: "Payment cancelled. You can retry whenever you want.",
  },
  rsvp: {
    page_title: "Confirm your attendance",
    your_name: "Your name",
    your_email: "Your email",
    pax_label: "Number of guests (you included)",
    diet_label: "Allergies / dietary needs",
    diet_placeholder: "e.g. Vegetarian, Gluten-free…",
    allergies_label: "Food allergies",
    allergies_placeholder: "e.g. Peanuts, Tree nuts, Gluten (celiac)",
    intolerances_label: "Intolerances / preferences",
    intolerances_placeholder: "e.g. Lactose, Vegetarian, Vegan",
    notes_label: "Notes for the couple",
    rsvp_yes: "I'll attend",
    rsvp_no: "I can't make it",
    submit: "Send",
    submitted: "Thank you! Your reply has been registered.",
    not_found: "Event not found.",
    invalid_link: "Invalid or disabled RSVP link.",
  },
  diet: {
    diet: "Diet",
    allergies: "Allergies",
    allergies_short: "Allergy",
    intolerances: "Intolerances",
    intolerances_short: "Intolerance",
    has_restrictions: "{{n}} with restrictions",
    no_restrictions: "No dietary restrictions reported",
    add_chip: "Add and press Enter",
    placeholder_allergies: "e.g. Peanuts, Gluten, Tree nuts",
    placeholder_intolerances: "e.g. Lactose, Vegetarian, Vegan",
  },
  email_tpl: {
    section_title: "Transactional emails",
    section_desc: "Customize the emails you send to couples and clients.",
    config_missing: "Configuration missing: set RESEND_API_KEY in the backend environment to actually send emails. Templates are saved either way.",
    config_ok: "Email service active. Sender: {{sender}}",
    types: {
      payment_reminder: "Payment reminder to couple",
      questionnaire: "Client questionnaire link",
      welcome: "Welcome confirmed client",
    },
    subject: "Subject",
    body: "Content",
    body_hint: "You can use basic HTML (<strong>, <em>, <a>, <p>) for formatting.",
    save: "Save template",
    saved: "Template updated",
    reset: "Reset to default",
    reset_done: "Template reset",
    test_send: "Test send",
    test_send_title: "Send test email",
    recipient: "Recipient",
    pick_client: "Pick couple (client)",
    pick_client_placeholder: "Select from your clients…",
    pick_client_hint: "Selecting a couple auto-fills email and template variables.",
    send: "Send",
    sent: "Email sent",
    variables: "Available variables",
    is_custom: "Custom",
    is_default: "Default",
    logs_title: "Recent emails sent",
    no_logs: "No emails sent yet.",
  },
  wp: {
    section_title: "WordPress integration",
    section_desc: "Connect your WordPress site RSVP plugin to automatically receive RSVPs into the CRM.",
    not_connected: "Not connected. Generate your API key to link the plugin.",
    connected: "Connected",
    synced_count: "Synced RSVPs",
    last_sync: "Last sync",
    api_key: "API key",
    key_once: "Copy it now: it will not be shown again",
    key_hidden: "Hidden. Regenerate the key to get a new one.",
    ingest_url: "RSVP endpoint (POST)",
    events_url: "Events endpoint (GET)",
    header_label: "Auth header",
    copy: "Copy",
    copied: "Copied",
    generate: "Generate API key",
    regenerate: "Regenerate key",
    regenerated: "Key regenerated",
    disconnect: "Disconnect",
    disconnected: "Integration disconnected",
    docs_title: "How to use",
    docs_lines: [
      "1. Install the Aurea Pro RSVP plugin on your WordPress site.",
      "2. Paste the API key below into the plugin settings.",
      "3. The plugin will fetch the list of events from the events endpoint.",
      "4. When a guest submits an RSVP from your site, the plugin will POST to the RSVP endpoint.",
    ],
    payload_title: "Sample payload",
  },
  guests: {
    add_title: "Add guest",
    edit_title: "Edit guest",
    name: "Name",
    email: "Email",
    phone: "Phone",
    rsvp_status: "RSVP status",
    group_family: "Group / Family",
    group_family_hint: "e.g. Smith family",
    dietary_section: "Dietary preferences",
    menu_choice: "Menu",
    menu_placeholder: "— Menu —",
    menu_inherits: "Inherits from primary",
    allergies: "Allergies",
    intolerances: "Intolerances",
    allergies_hint: "e.g. Gluten, Peanuts, Tree nuts",
    intolerances_hint: "e.g. Lactose, Sorbitol, Sulphites",
    yes: "Yes",
    no: "No",
    companions: "Companions",
    companion_add: "Add",
    companion_name: "Companion {{n}}",
    companions_empty: "No companions — click \"Add\" to insert one.",
    total: "Total",
    person_one: "{{n}} person",
    person_many: "{{n}} people",
    table: "Table",
    no_table: "— No table —",
    export_catering_csv: "Catering CSV",
    export_catering_pdf: "Catering PDF",
    delete_confirm: "Are you sure you want to delete this guest and their companions?",
  },
};

export default en_extra;
